import React, { useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import jwt_decode from 'jwt-decode';
import "../assets/css/styles.table.css"
import '../assets/additional-css/styles.css';
import Sidebar from './Sidebar';
import Header from './Header';
//for table
import Box from '@mui/material/Box';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import {apiUrl} from './UrlParam'; 
import AxiosFetchData from './AxiosFetchData';
//import ApexChart from '../assets/apexchart'
//import ApexCharts from 'apexcharts'
//import { lazy } from 'react';
// import Donut from './Piechart';
 import Highcharts from 'highcharts';
 import ApexChart from 'apexcharts';
import { auto, right } from '@popperjs/core';
import Helper from './Helper';
import Layout from './Layout';
import {useExecutiveDashboardHook} from '../hook/ExecutiveDashboardHook'

const ExecutiveDashboard = () => {
  const {message,setmessage,tipe,settipe,refreshChart,projectCount,clientCount,anggaran,taskCount,taskSelesaiCount,
          Chart5Paging,page,Chart7Paging,pageChart7,Chart8Paging,pageChart8,Chart14Paging,pageChart14
        } = useExecutiveDashboardHook();
 
  return (
    <> 
      <Layout message={message} setmessage={setmessage} tipe={tipe} settipe={settipe}>
                <div className='pd'><b>EXECUTIVE DASHBOARD </b> </div>
                <div className='pd'>
                <div style={{textAlign:right}}>
                    <button type='button' id="btnRefresh" className='btn btn-primary' onClick={refreshChart}>Refresh</button>
                </div>
               <div className="section1">
                    
                       <div className='headerBox0' >{projectCount} Project</div>
                       <div className='headerBox0'>{clientCount} Client</div> 
                       <div className='headerBox0'>Budget IDR  {Helper.formatAsCurrency(anggaran)} </div> 
                       <div className='headerBox0'>{taskCount} Task   </div> 
                </div>
                {/* <div className="section2">
                    
                       <div>SEMUA TUGAS BERDASARKAN STATUS </div>
                       <div>SEMUA TUGAS BERDASARKAN PRIORITAS </div> 
                       <div>SEMUA TUGAS BERDASARKAN KOMPLEKSITAS </div> 
                        
                </div> */}
                <div className="section3">
                    
                       <div className='headerBox'>
                            <div className='title'>ALL TASK BY STATUS </div>
                           
                            <div id="chart"></div>
                       </div>
                     
                       <div  className='headerBox'>
                            <div className='title'>ALL TASK BY PRIORITY </div>  
                            <div id="chart2">   </div>
                          
                       </div> 
                       <div  className='headerBox'> 
                            <div className='title'>ALL TASK BY COMPLEXITY </div> 
                            <div id="chart3"></div>
                        </div> 
                        
                </div>

                <div className="section4">
                    
                    <div className='headerBox1'>
                         <div className='title'>{taskSelesaiCount} DARI {taskCount} COMPLETED TASK </div>
                         <div id="chart4" ></div>
                    </div>
                    <div className='headerBox2' style={{position:'relative'}}>
                        <div className='title'>PROJECT SCHEDULE
                          <div style={{position:'absolute', right:15,top:20}}>
                          <button type='button'  onClick={(e) => Chart5Paging("prev", page - 1)}>Prev</button>  <button type='button'  onClick={(e) =>Chart5Paging("next",page + 1)}>Next</button>
                          </div>
                      
                        </div> 
                        <div id="chart5"></div>
                    </div> 
                </div>

               
                </div>

                <div className='pd_headline'><b>BUDGET</b><br /> <br /></div>
                <div className='pd'>
                <div className="section6">
                    <div  className='headerBox6' style={{position:'relative'}}>
                        <div className='title'>PROJECT VALUE
                        <div style={{position:'absolute', right:15,top:20}}>
                          <button type='button'  onClick={(e) => Chart7Paging(pageChart7 - 1)}>Prev</button>  <button type='button'  onClick={(e) =>Chart7Paging(pageChart7 + 1)}>Next</button>
                          </div>

                        </div>
                        
                          <div id="chart7" ></div>
                         
                        
                    </div>
                    
                    {/* <div className='headerBox6'>
                            <div className='title'>JAM YANG DIRENCANAKAN VS SEBENARNYA</div>
                            <div id="chart9"></div>
                        </div> */}
                    
                </div>
                </div>

                <div className='pd_headline'><b>REALIZATION</b><br /> <br /></div>
                <div className='pd'>
                <div className="section7">
                <div  className='headerBox6' style={{position:'relative'}}>
                        <div className='title'>PROJECT #CREDIT
                        <div style={{position:'absolute', right:15,top:20}}>
                          <button type='button'  onClick={(e) => Chart8Paging(pageChart8 - 1)}>Prev</button>  <button type='button'  onClick={(e) =>Chart8Paging(pageChart8 + 1)}>Next</button>
                          </div>
                        </div>
                        <div  id="chart8"></div>
                    </div>
                    <div  className='headerBox6' style={{position:'relative'}}>
                        <div className='title'> PROJECT #DEBIT
                        <div style={{position:'absolute', right:15,top:20}}>
                          <button type='button'  onClick={(e) => Chart14Paging(pageChart14 - 1)}>Prev</button>  <button type='button'  onClick={(e) =>Chart14Paging(pageChart14 + 1)}>Next</button>
                          </div>
                        </div>
                        <div  id="chart14"></div>
                    </div>
                  </div>

                </div>
 
                <div className="pd">
                    <Box sx={{ width: 1 }} >
       
                    </Box>
                </div>

                </Layout>
              
    </>
  );
};

export default ExecutiveDashboard;